import { render, staticRenderFns } from "./inStockRecord.vue?vue&type=template&id=2e2d58b8&"
import script from "./inStockRecord.vue?vue&type=script&lang=js&"
export * from "./inStockRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports